import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLocalizedPath } from '../hooks/useLocalizedPath';
import { useI18nLocaleSync } from '../hooks/useI18nLocaleSync';
import { useAppLocale } from '../hooks/useAppLocale';
import { pathWithLocale } from '../lib/locale';
import { ContactBodyEn, ContactBodyKo } from './content/ContactBodies';

export function Contact() {
  const { t } = useTranslation();
  const locale = useAppLocale();
  const lp = useLocalizedPath();

  useI18nLocaleSync();

  usePageMeta({
    title: locale === 'ko' ? '연락처 – 로또 번호 생성기' : t('contactPage.metaTitle'),
    description:
      locale === 'ko'
        ? '로또 번호 생성기 팀에 문의, 피드백, 버그 신고, 비즈니스 문의를 보내주세요.'
        : t('contactPage.metaDesc'),
    path: pathWithLocale('/contact', locale),
    noindex: locale !== 'en' && locale !== 'ko',
  });

  return (
    <main className="content">
      <nav className="breadcrumb" aria-label={t('layout.breadcrumbLabel')}>
        <Link to={lp('/')}>{t('breadcrumb.home')}</Link>
        <span className="sep">/</span>
        <span className="current">{t('nav.contact')}</span>
      </nav>

      {locale === 'ko' ? <ContactBodyKo lp={lp} /> : <ContactBodyEn lp={lp} />}
    </main>
  );
}
